var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2.00006C8.12988 2.00006 4.99988 5.13007 4.99988 9.00007C4.99988 14.2501 11.9999 22.0001 11.9999 22.0001C11.9999 22.0001 18.9999 14.2501 18.9999 9.00007C18.9999 5.13007 15.8699 2.00006 11.9999 2.00006ZM11.9999 11.5001C11.3368 11.5001 10.701 11.2367 10.2321 10.7678C9.76328 10.299 9.49988 9.66311 9.49988 9.00007C9.49988 8.33702 9.76328 7.70114 10.2321 7.2323C10.701 6.76346 11.3368 6.50006 11.9999 6.50006C12.6629 6.50006 13.2988 6.76346 13.7676 7.2323C14.2365 7.70114 14.4999 8.33702 14.4999 9.00007C14.4999 9.66311 14.2365 10.299 13.7676 10.7678C13.2988 11.2367 12.6629 11.5001 11.9999 11.5001Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.65c99b8cf980d2508aac9ef9b7581661.svg";
export { ForwardRef as ReactComponent };